import { render, staticRenderFns } from "./ListRef.vue?vue&type=template&id=50b279f0&scoped=true"
import script from "./ListRef.vue?vue&type=script&lang=js"
export * from "./ListRef.vue?vue&type=script&lang=js"
import style0 from "./ListRef.vue?vue&type=style&index=0&id=50b279f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b279f0",
  null
  
)

export default component.exports